import { render, staticRenderFns } from "./vimeomobile.vue?vue&type=template&id=2486f3f7&"
import script from "./vimeomobile.vue?vue&type=script&lang=js&"
export * from "./vimeomobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports